import { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasStickyCTA, setHasStickyCTA] = useState(false);

  useEffect(() => {
    let ticking = false;

    const toggleVisibility = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setIsVisible(window.scrollY > 300);
          // Check if a sticky CTA is present on the page
          const stickyCTA = document.querySelector('.fixed.bottom-0.lg\\:hidden');
          setHasStickyCTA(!!stickyCTA && window.scrollY > window.innerHeight * 0.5);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <Button
      asChild
      size="icon"
      className={cn(
        'fixed right-4 sm:right-8 z-50 rounded-full shadow-lg transition-all duration-300 h-12 w-12 bg-primary hover:bg-primary/90 text-primary-foreground',
        // Sur mobile : au-dessus de la bottom nav (56px) + sticky CTA éventuel (80px)
        hasStickyCTA
          ? 'bottom-[calc(9rem+env(safe-area-inset-bottom))] xl:bottom-[calc(5rem+env(safe-area-inset-bottom))]'
          : 'bottom-[calc(5rem+env(safe-area-inset-bottom))] xl:bottom-[calc(2rem+env(safe-area-inset-bottom))]',
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16 pointer-events-none'
      )}
      aria-label="Nous contacter"
    >
      <a href="/contact">
        <MessageCircle className="h-5 w-5" />
      </a>
    </Button>
  );
};
